import posthog from 'posthog-js'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig()
  const userStore = useUserStore()
  const router = useRouter()

  if (runtimeConfig.public.nuxtEnv !== 'production') {
    return
  }

  const posthogClient = posthog.init(runtimeConfig.public.posthogPublicKey, {
    api_host: runtimeConfig.public.posthogHost,
    capture_pageview: false,
    debug: false,
    person_profiles: 'always', // Save sessions for all users
    verbose: false,
  })

  watch(
    () => userStore.user,
    (user) => {
      if (user) {
        posthog.identify(`${user.id}`, {
          avatar: user.pictureUrl,
          email: user.email,
          name: user.fullName,
          teamId: user.currentTeamId,
          userId: user.id,
        })

        // Exclude people from The Companies API team from PostHog
        if (user.currentTeamId === 1) {
          posthog.opt_out_capturing()
        }
      }
      else {
        posthog.reset()
      }
    },
    { immediate: true },
  )

  router.afterEach((to, from) => {
    nextTick(() => {
      try {
        // Track page views
        posthog.capture('$pageleave', { current_url: from.fullPath })
        posthog.capture('$pageview', { current_url: to.fullPath })
      }
      catch {}
    })
  })

  nuxtApp.hook('vue:error', (error) => {
    posthogClient.captureException(error)
  })

  return { provide: { posthog: () => posthogClient } }
})
